<script setup lang="ts">
import { resources } from '@/config/brands'
</script>

<template>
  <div style="display: inline-block; width: 40px; height: 40px">
    <img style="width: 100%; animation: spin 1s linear infinite" :src="resources.spinner" alt="">
  </div>
</template>

<style scoped>
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
